import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import Form from "./Form";
import Preview from "./Preview";

import { ReactComponent as CloseIcon } from "assets/images/icon_close_modal.svg";

import { useInvoiceActions } from "./hooks/useInvoiceActions";
import { useInvoiceFormState } from "./hooks/useInvoiceFormState";
import { useDynamicManifest } from "./hooks/useDynamicManifest";
import { FormValues, validationSchema } from "./validation";
import { IbanAccount } from "store/features/ibanAccountSlice";

import { styles } from "./styles";

const CreateInvoiceMain: React.FC = () => {
  useDynamicManifest();

  const {
    initialValues,
    activeAccounts: accounts,
    isLoading,
  } = useInvoiceFormState();

  const { submitting, onSubmit, onGoBack } = useInvoiceActions();

  const methods = useForm<FormValues>({
    mode: "onSubmit",
    resolver: yupResolver(validationSchema),
    values: initialValues,
  });

  const onSelectAccount = (account: IbanAccount) => {
    methods.setValue("bankName", account?.bank?.name || "");
    methods.setValue("organizationName", account?.organizationName || "");
    methods.setValue("identificationCode", account?.identificationCode || "");
    methods.setValue("iban", account?.iban || "");
    methods.setValue("publicName", account?.publicName || "");
  };

  return (
    <Stack sx={styles.container}>
      <Stack direction="row" sx={styles.header}>
        <Typography variant="body1">Створити посилання</Typography>
        <IconButton
          aria-label="cancel-create-invoice"
          sx={{ p: 0 }}
          onClick={onGoBack}
        >
          <CloseIcon />
        </IconButton>
      </Stack>

      <Stack direction="row" sx={styles.content}>
        <FormProvider {...methods}>
          <Box sx={styles.formWrapper}>
            <Form
              accounts={accounts}
              onSubmit={methods.handleSubmit(onSubmit)}
              onSelectAccount={onSelectAccount}
              dataLoading={isLoading}
              loading={submitting}
            />
          </Box>
          <Preview />
        </FormProvider>
      </Stack>
    </Stack>
  );
};

export default CreateInvoiceMain;
